import { CategoryDescriptionProps } from "@/utils/formatCategoryPage";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./CategoryDescription.module.scss";

export const CategoryDescription = ({
  title,
  articles,
}: CategoryDescriptionProps) => {
  return (
    <div className={styles.categoryDescription}>
      <h2 className={styles.title}>{title}</h2>
      {articles.map((article, index) => (
        <div className={styles.description} key={index}>
          {article.title && (
            <p className={styles.descriptionTitle}>{article.title}</p>
          )}
          <div
            className={styles.descriptionText}
            dangerouslySetInnerHTML={injectPurifiedHTML(
              removeEmptyRel(article.text)
            )}
          />
        </div>
      ))}
    </div>
  );
};
